import { createContext } from 'react';

export type UpdateAuthorizedIpsCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  UpdateError: string;
};

const UpdateAuthorizedIps = createContext<UpdateAuthorizedIpsCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  UpdateError: '',
});

export default UpdateAuthorizedIps;
